import React, { useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal'; // Added missing import
import axios from "../api/axios";
import { Apitoken, Authtoken } from "../Global";
import { toast } from "react-toastify";
import PropTypes from 'prop-types'; // Added for prop validation


const EditDecayCustomerPayment = ({ itemId, handleClose, show }) => {

  const [backendSuccess, setBackendSuccess] = useState(null);
  const [backendErrors, setBackendErrors] = useState([]);
  const [formData, setFormData] = useState({});
  const [paymentmethod] = useState([
    { id: 'Virement', text: "Virement" },
    { id: 'Espece', text: "Espece" },
    { id: 'Cheque', text: "Cheque" }
  ]);
 let season_id = localStorage.getItem("season_id");

  console.log("itemId");
  console.log(itemId);
  useEffect(() => {
  
    axios
      .get(`/decay-sales/edit-customer-payment/${season_id+'-'+itemId}`, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        if (response.data.code === 200) {
          let amount = response.data.data.payment.cost;
          let edit_Data = response.data.data.payment;
          edit_Data.amount = amount;
          edit_Data.season_id = season_id;
          
          setFormData(edit_Data);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [itemId]);

  // const categoryHandler = () => {
  //   setshowCategory(true);
  //   console.log("here open");
  // };

  // const handleClose = () => {
  //   setshow(false);
  //   setshowCategory(false);
  //   props.handleClose();
  // };

  // const handleClick = () => {
  //   setshow(true);
  // };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
    axios
      .post("/decay-sales/update-customer-payment", formData, {
        headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
      })
      .then((response) => {
        setBackendErrors(prev => {
          const newErrors = { ...prev };
          delete newErrors['error'];
          return newErrors;
        });

        if (response.data.code === 200) {
          setBackendSuccess(response.data.message);
          toast.success(response.data.message);
          setTimeout(() => {
            window.location.href = "/decay-sales-customer/" + formData.customer;
          }, 500);
        } else if (response.data.code === 422) {
          setBackendErrors(response.data.error);
        } else if (response.data.code === 401) {
          setBackendErrors(response.data.error);
        } else {
          setBackendErrors(response.data.error);
        }
      })
      .catch((error) => {
        console.log(error);
        // Removed reference to undefined 'actions'
      });
  };

  const customHandleInput = (event) => {
    const input_name = event.target.name;
    setBackendErrors(prev => {
      const newErrors = { ...prev };
      delete newErrors[input_name];
      return newErrors;
    });
  };

  return (
    <>
      <Modal centered show={show} onHide={handleClose}>
        <Modal.Header>
          <h4 className="modal-title">Edit Customer Payment</h4>
          <button type="button" className="close" data-bs-dismiss="modal" onClick={handleClose} aria-hidden="true">&times;</button>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit}>
            {backendSuccess && (
              <div className="from-success mt-1">
                {backendSuccess}
              </div>
            )}

            <div className="form-group">
              <label>Date</label>
              <input
                className="form-control form-white"
                placeholder="Select Date"
                type="date"
                name="date"
                value={formData.date || ''}
                onChange={(e) => {
                  handleChange(e);
                  customHandleInput(e);
                }}
              />
              <small>{backendErrors.date && (<span className="form-error mt-1">{backendErrors.date}</span>)}</small>
            </div>
            
            <div className="form-group">
              <label>Amount </label>
              <input
                className="form-control form-white"
                placeholder="Enter amount"
                type="text"
                onKeyPress={(event) => {
                  if (!/^[0-9.]$/.test(event.key) || (event.key === '.' && event.target.value.includes('.'))) {
                    event.preventDefault();
                  }
                }}
                name="amount"
                value={formData.amount || ''}
                onChange={(e) => {
                  handleChange(e);
                  customHandleInput(e);
                }}
              />
              <small>{backendErrors.amount && (<span className="form-error mt-1">{backendErrors.amount}</span>)}</small>
            </div>

            {paymentmethod.length > 0 && (
              <div className="form-group mb-0">
                <label>Select Payment Type </label>
                <select
                  className="form-control form-white"
                  data-placeholder="Select Payment Type"
                  name="payment_method"
                  value={formData.payment_method || ''}
                  onChange={(e) => {
                    handleChange(e);
                    customHandleInput(e);
                  }}
                >
                  <option value=''>Select</option>
                  {paymentmethod.map((shipp) => (
                    <option
                      key={shipp.id}
                      value={shipp.id}
                    >
                      {shipp.text}
                    </option>
                  ))}
                </select>
                <small>{backendErrors.payment_method && (<span className="form-error mt-1">{backendErrors.payment_method}</span>)}</small>
              </div>
            )}

            <div className="form-group">
              <label>Note: </label>
              <textarea
                className="form-control form-white"
                placeholder="Enter Note"
                name="note"
                value={formData.note || ''}
                onChange={(e) => {
                  handleChange(e);
                  customHandleInput(e);
                }}
              ></textarea>
              <small>{backendErrors.note && (<span className="form-error mt-1">{backendErrors.note}</span>)}</small>
            </div>
            
            <div className="submit-section">
              <button type="submit" className="btn btn-primary save-category submit-btn" data-bs-dismiss="modal">UPDATE</button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
    </>
  );
};

// Added PropTypes validation
EditDecayCustomerPayment.propTypes = {
  // itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Accepts string or number
  
  //show: PropTypes.string.isRequired,
    show: PropTypes.bool.isRequired, // Must be a boolean
  
  handleClose: PropTypes.func.isRequired
};

export default EditDecayCustomerPayment;